import { useMutation } from '@tanstack/react-query';

import type {
  BookingEmailTemplateMutationResponse,
  SendBookingTestEmailData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useSendBookingTestEmailMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: SendBookingTestEmailData }) =>
      HttpClient.request<BookingEmailTemplateMutationResponse>({
        method: 'POST',
        url: params.url,
        data: { booking_test_email: params.data },
      }),
  });
